export default __webpack_public_path__ + "static/media/Login.4936b1c4.jpg";